import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() text: string = '';
  @Input() customClass: string = '';
  @Input() colorscheme: string = '';
  @Input() icon: string = '';
  @Input() customStyles: { any };
  @Input() type: string = '';
  @Input('inactive') disabled: boolean = false;

  constructor() { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/button/button.component.ts